import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import 'hammerjs';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

declare var jQuery:any;
declare var $:any;


if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));






// WEBPACK FOOTER //
// C:/Users/PRO/Documents/GitHub/CGStore-Front/src/main.ts